<template lang="pug">
  div
    div.pc(:style="{paddingTop:isWechat ? '0':'60px'}")
      div.wrapper(v-show='!isWechat')
        div(:style="{backgroundImage:'url('+require('../../assets/images/alpha-logo.png')+')',width: '35px', height: '35px', 'background-size': 'cover',margin: '12px 0 0 20px',}")
        //- span(style="color:#909399;font-size:18px;font-weight:bold;line-height:60px;padding-left:20px;background-color:#fff") 阿尔法系统
        navigation-bar( ref="nav" :msgCount="msgCount" style="padding-left:0px!important")
        div.nav-btn.search-btn
          el-button(v-show="collapsed", type="primary" ,size='small' dark, @click="onPull") 快速搜索
          el-button(v-show="!collapsed", type="primary", size='small' dark, @click="onPush") 收起
      div.search-bar(v-show="!collapsed")
        //- drawer(ref="drawer")
        NewDrawer(ref="drawer")
      router-view(ref="main")
    radishAdd(ref='radishAdd')
    radishCvUpload(ref="radishCvUpload")
    radishExcelUpload(ref="radishExcelUpload")
    radishQuickAdd(ref="radishQuickAdd")
    departmentOchart(ref="departmentOchart")
    CvPreview(ref="cvPreview")
    SalaryEdit(ref="salaryEdit" width="40%")
    AddRadishDrawer(ref="addRadishDrawer")
    OnekeyMatchDrawer(ref="OnekeyMatchDrawer")
    radishDetailTab(ref="radishDetailTab")
    radishProDialog(ref="radishProDialog")
    radishLeft(ref="radishLeft")
    selectCompany(ref="selectCompany")
    radishEditCompany(ref='radishEditCompany')
    ProjectDetailEditor(ref='addProjectFull')
    twothird(ref='companyTwoThird')
    orderDialog(ref='orderDialog')
    simiDialog(ref="simiDialog")
    mappingOchart(ref="mappingOchart")
    UploadDialog(ref="upload" :on-success="onSuccess" :type="uploadType" :label="uploadType")
    ReportMaker(ref="reportMaker")
    FollowDrawer(v-if="$route.path === '/radish'" ref="followDrawer")
    NotifyList(ref="NotifyList")
    radishScore(ref="radishScore")
    favDialog(ref="favDialog")
    ExcelCorrection(ref="ExcelCorrection")
    DupList(ref="DupList")
    DupDetail(ref="DupDetail")
    InterviewGrade(ref="InterviewGrade")
    companySuperList(ref="companySuperList")
    companyFundChart(ref="companyFundChart")
    yejiDialog(ref="yejiDialog")
    formerYearsList(ref="formerYearsList")
    CompanyReportDialog(ref="CompanyReportDialog")
    RadishPortrait(ref="RadishPortrait")
    resetPass(ref="resetPass")
    createCompany(ref="createCompany")
    NewAddProject(ref="NewAddProject")
    //- TodayTask(ref="TodayTask")
    NewProjectProgressDialog(ref="NewProjectProgressDialog")
    ChooseCity(ref="ChooseCity")
    TeamDetail(ref="TeamDetail")
    makePayDoc(ref="makePayDoc")
    makePayDocTmpl(ref="makePayDocTmpl")
    TrainingVideoDialog(ref="TrainingVideoDialog")
    CvmatchLoading(ref="CvmatchLoading")
    PeixunDia(ref="PeixunDia")
    ReportTemplateV2(ref="ReportTemplateV2")
    RecommendAuthorization(ref="RecommendAuthorization")
    ClientCompanyCountEditor(ref="ClientCompanyCountEditor")
    ClientCompanyCountResultDialog(ref="ClientCompanyCountResultDialog")
    CommendatoryClientCompanyCountEditor(ref="CommendatoryClientCompanyCountEditor")
    CommendatoryClientCompanyCountResultDialog(ref="CommendatoryClientCompanyCountResultDialog")
    ZnAlpha(ref="ZnAlpha")
    Chuangguan(ref="Chuangguan")
    WpsDialog(ref="WpsDialog")
    ProjectReportEditor(ref="ProjectReportEditor")
    MappingReportChooseHeaderDialog(ref="MappingReportChooseHeaderDialog")
    GetClientYearReportDialog(ref="GetClientYearReportDialog")
    ModifyClientYearReportDialog(ref="ModifyClientYearReportDialog")
    //- ToworkNotify(ref="ToworkNotify")

    div(class="img-water-mark-one" v-for="i in 12" :key="i" :style="{ top: (Math.ceil(i / 3) - 1) * 200 + 'px', left: i % 3 == 1 ? '20%' : i % 3 == 2 ? '40%' :'60%' }") {{ account }}

</template>

<script>
import {
  // fullCompany,
  createCompany,
  departmentOchart,
  mappingOchart,
  radishScore,
  twothird,
  InterviewGrade,
  companySuperList,
  companyFundChart,
  formerYearsList,
  selectCompany,
} from '../../company'
import { CvPreview, UploadDialog, SalaryEdit } from '../../file'
import {
  ProjectDetailEditor,
  AddRadishDrawer,
  OnekeyMatchDrawer,
  CvmatchLoading,
  ReportMaker,
  ReportTemplateV2,
  FollowDrawer,
  NewAddProject,
  NewProjectProgressDialog,
  ChooseCity,
} from '../../project'

import resetPass from './resetPass'
// import TodayTask from './todaytask/TodayTask'
import NewDrawer from './NewDrawer/drawer'
import TeamDetail from './TeamDetail'
import TrainingVideoDialog from './TrainingVideoDialog'
import RecommendAuthorization from './RecommendAuthorization'
import ClientCompanyCountEditor from './clientManage/ClientCompanyCountEditor.vue'
import ClientCompanyCountResultDialog from './clientManage/ClientCompanyCountResultDialog.vue'
import CommendatoryClientCompanyCountEditor from './clientManage/CommendatoryClientCompanyCountEditor.vue'
import CommendatoryClientCompanyCountResultDialog from './clientManage/CommendatoryClientCompanyCountResultDialog.vue'
import ZnAlpha from './ZnAlpha/ZnAlpha.vue'
import Chuangguan from './chuangguan/index.vue'
import ProjectReportEditor from './clientManage/ProjectReportEditor.vue'
import WpsDialog from './WpsDialog.vue'
import MappingReportChooseHeaderDialog from './mappingReportChooseHeaderDialog'
import GetClientYearReportDialog from './GetClientYearReportDialog'
import ModifyClientYearReportDialog from './ModifyClientYearReportDialog'
// import ToworkNotify from './ToworkNotify'

export default {
  name: 'App',
  components: {
    ProjectDetailEditor,
    AddRadishDrawer,
    OnekeyMatchDrawer,
    CvmatchLoading,
    ReportMaker,
    ReportTemplateV2,
    FollowDrawer,
    CvPreview,
    SalaryEdit,
    // fullCompany,
    departmentOchart,
    mappingOchart,
    radishScore,
    twothird,
    formerYearsList,
    InterviewGrade,
    companySuperList,
    companyFundChart,
    resetPass,
    createCompany,
    NewAddProject,
    // TodayTask,
    NewProjectProgressDialog,
    ChooseCity,
    NewDrawer,
    TeamDetail,
    TrainingVideoDialog,
    RecommendAuthorization,
    ClientCompanyCountEditor,
    ClientCompanyCountResultDialog,
    ZnAlpha,
    Chuangguan,
    ProjectReportEditor,
    WpsDialog,
    MappingReportChooseHeaderDialog,
    CommendatoryClientCompanyCountEditor,
    CommendatoryClientCompanyCountResultDialog,
    selectCompany,
    GetClientYearReportDialog,
    ModifyClientYearReportDialog,
    // ToworkNotify,
  },
  data() {
    return {
      collapsed: true,
      dragindex: 1003,
      uploadType: '',
      msgCount: undefined,
      isWechat: /MicroMessenger/i.test(window.navigator.userAgent),
    }
  },
  computed: {
    account() {
      return app.user.account
    },
  },
  mounted() {
    app.root = this
    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')

    // const url = window.location.href.includes('https')
    //   ? 'https://doc.aconsulting.top:11001/web-apps/apps/api/documents/api.js'
    //   : 'https://doc.aconsulting.top:11001/web-apps/apps/api/documents/api.js'
    // // : `http://47.93.158.22:11000/web-apps/apps/api/documents/api.js`
    const url = 'https://docapi.alphaconsulting.com.cn:12001/web-apps/apps/api/documents/api.js'
    // const url = 'http://47.120.39.30:11001/web-apps/apps/api/documents/api.js'
    // console.log('🚀 ~ file: app.vue:186 ~ mounted ~ url:', url)
    script.setAttribute('src', url)
    script.async = true
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(script)
  },
  methods: {
    onPull() {
      this.collapsed = false
      this.$refs.drawer.init()
    },
    onPush() {
      return (this.collapsed = true)
    },
    closeDetail() {
      this.detailType = ''
    },
    search({ type, keywords, result, id }) {
      if (!type && !keywords) return
      if (this.collapsed) this.collapsed = false
      this.$refs.drawer.search({ type, keywords, result, id })
    },
    upload(type, listOption) {
      this.uploadType = type || ''
      this.listOption = listOption
      this.$refs.upload && this.$refs.upload.visible(true)
    },
    async onSuccess(response, file, fileList) {
      this.$refs.main.$refs.fileTable && this.$refs.main.$refs.fileTable.getFiles()
      const { md5, uploader, _id, type } = (response && response[0]) || {}
      if (type === 'list') {
        if (this.listOption)
          await app.service('company').modifyDocument({ query: { md5: md5 }, data: { listOption: this.listOption } })
        try {
          await app.service('file').confuseXlsx({ md5, uploader, _id, type })
        } catch (e) {
          console.error(e)
        }
      }
    },
  },
}
</script>
